import CONST from "./Constant";

const INITIAL_STATE = {
    departments:[],
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.FETCH_STATS_SUCCESS:
            return {
                ...state,
                departments: action.payload.data || [],
                error:[],
                code:200
            }
        case CONST.FETCH_STATS_FAILED:
            return {
                ...state,
                departments: [],
                error: action.payload.data?.errors || [],
                message: [action.payload],
                code: action.payload.status,
            }
        default:
            return state;
    }
}

export default Reducer ;